import { GsFormSchema } from '../../../components';
import { BASIC_SCHEMA_FIELDS } from '../basics';

export const SPACER_SLIDE_COMPONENT_SCHEMA: GsFormSchema = {
  fields: [
    ...BASIC_SCHEMA_FIELDS,
    {
      formControlName: 'height',
      label: 'gallerySlideComponents.spacer.schema.height.label',
      type: 'number',
      min: 64,
      step: 16,
      isResponsive: true,
      default: {
        default: 128
      }
    }
  ]
};
